// react library imports
import { useState, useEffect, useRef } from 'react';
import { CaretDown, CaretUp} from 'phosphor-react';

// import from utils
import { useClickOutside } from "Utils/common";

// style import 
import 'Component/Form/ClassTextField/ClassTextField.css';
import 'Component/Form/Input/Input.css';
import './SelectTextField.css';

const SelectTextField = ({label, list, initialValue, onChange, fullNameList, id}) => {
    const [dropdown, setDropDown]=useState(false)
    const [value, setValue]=useState("")
    const focus=[value].every(Boolean)
    const boxRef = useRef()

    useEffect(()=>{
        if (initialValue) {
            setValue(initialValue)
        }
    }, [initialValue])

    // handle onchange event
    const handleOnchange=(e)=>{
        if (fullNameList) {
            setValue(e)
            onChange(e)
        }else{
            setValue(e.name)
            onChange(e.name)
        }
    }
    useClickOutside(boxRef, ()=>setDropDown(false));
  return (
    <div className={`form-input multi_select_input_field 
    select_text_field_container mues_pointer ${dropdown && 'select_active_text_field'}`}
    onClick={()=>setDropDown(!dropdown)} id={id} ref={boxRef}>
        {!fullNameList && <p className='mues_grey_I mues_font_weight_600'>{value}</p>}
        {fullNameList && <p className='mues_grey_I mues_font_weight_600'>{value?.first_name} {value?.last_name}</p>}
        <label className={focus?'form_focus':""}>{label}</label>
        {dropdown ? <CaretUp className='edit_label mues_pointer' weight='fill'/>:<CaretDown className='edit_label mues_pointer' weight='fill'/>}
        {dropdown && <div className='multi_select_list_container mues_white_background
        mues_grey_II'>
           {!fullNameList && list.map(item=>(
                <div className={`mues_pointer multi_select_item`} key={item.id}
                onClick={()=>handleOnchange(item)}>
                    <p className='mues_font_weight_400'>{item.name}</p>
                </div>
            ))}
           {fullNameList && list.map(item=>(
                <div className={`mues_pointer multi_select_item`} key={item.id}
                onClick={()=>handleOnchange(item)}>
                    <p className='mues_font_weight_400'>{item.first_name} {item.last_name}</p>
                </div>
            ))}
        </div>}
    </div>
  )
}

export default SelectTextField